export default "__VITE_ASSET__31896432__$_?nuxt_component=async__"